/* Veil and Violet Luxury Shopify Theme Pack
   Add this file before </body> in theme.liquid:
   <script src="{{ 'melissa-luxury.js' | asset_url }}" defer="defer"></script>
*/

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mp-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mp-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });
  }

  document.querySelectorAll('[data-mp-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.mpFilter;
      const section = button.closest('.mp-section');
      const cards = section ? section.querySelectorAll('[data-mp-filter-tags]') : [];

      button.parentElement.querySelectorAll('[data-mp-filter]').forEach((chip) => {
        chip.classList.toggle('is-active', chip === button);
      });

      cards.forEach((card) => {
        const tags = card.dataset.mpFilterTags.split(' ');
        card.hidden = !(filter === 'all' || tags.includes(filter));
      });
    });
  });

  /* Shopify can render app-managed inventory as unavailable in Liquid even
     when the Online Store API has a sellable variant. Reconcile each retail
     card against Shopify's customer-facing product endpoint. */
  const refreshStockCard = async (card) => {
    const handle = card.dataset.vvProductHandle;
    if (!handle) return;

    try {
      card.dataset.vvStockCheck = 'loading';
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        card.dataset.vvStockCheck = `http-${response.status}`;
        return;
      }

      const product = await response.json();
      const availableVariant = product.variants?.find((variant) => variant.available);
      const stock = card.querySelector('.vv-card-stock');
      const button = card.querySelector('.vv-card-add');
      const variantInput = card.querySelector('.vv-card-cart-form input[name="id"]');
      if (!stock || !button) return;
      card.dataset.vvStockCheck = availableVariant ? 'available' : 'unavailable';

      stock.classList.toggle('is-out', !availableVariant);
      stock.lastChild.textContent = availableVariant ? ' In stock' : ' Out of stock';

      if (variantInput) {
        if (availableVariant) variantInput.value = availableVariant.id;
        button.textContent = availableVariant ? 'Add to basket' : 'Out of stock';
        button.classList.toggle('is-disabled', !availableVariant);
        button.disabled = !availableVariant;
      } else {
        button.textContent = availableVariant ? 'Choose options' : 'Out of stock';
        button.classList.toggle('is-disabled', !availableVariant);
        button.setAttribute('aria-disabled', String(!availableVariant));
      }
    } catch (error) {
      /* Keep the server-rendered state if the availability check is blocked. */
      card.dataset.vvStockCheck = `error-${error?.name || 'unknown'}`;
    }
  };

  const stockCards = Array.from(document.querySelectorAll('[data-vv-stock-card]'));
  let stockCardIndex = 0;
  const stockWorkers = Array.from({ length: Math.min(6, stockCards.length) }, async () => {
    while (stockCardIndex < stockCards.length) {
      const card = stockCards[stockCardIndex++];
      await refreshStockCard(card);
    }
  });
  Promise.all(stockWorkers);

  const revealItems = document.querySelectorAll('.mp-reveal');

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  revealItems.forEach((item) => observer.observe(item));
});
